import { createThemeCompiler } from '../../../utils';

export const popupMessageThemeCompiler = createThemeCompiler(({ palette }) => ({
    popupMessage: {
        colors: {
            error: {
                contentColor: palette.neutralPrimary,
                contentSeparatorColor: '#E5E8EE',
                titleColor: palette.neutralPrimary
            },
            information: {
                contentColor: palette.neutralPrimary,
                contentSeparatorColor: '#E5E8EE',
                titleColor: palette.neutralPrimary
            },
            success: {
                contentColor: palette.neutralPrimary,
                contentSeparatorColor: '#E5E8EE',
                titleColor: palette.neutralPrimary
            },
            warning: {
                contentColor: palette.neutralPrimary,
                contentSeparatorColor: '#E5E8EE',
                titleColor: palette.neutralPrimary
            }
        },
        composites: {}
    }
}));
